import Component from './text.component'
import { TextStyles } from './text.component'

export { TextStyles }
export default Component
